<template>
  <div :class="{'disableUpload':disableUpload}">
    <Upload
      action
      list-type="picture-card"
      :file-list="getAttachments"
      :limit="maxAllowed"
      :auto-upload="false"
      :multiple="multiple"
      :on-exceed="handleExceed"
      :on-change="addAttachment"
      :disabled="disableUpload || useModalUpload"
      class="default-upload flex-reverse is-badge"
      :class="{'is-disabled':disableUpload}"
     >
      <!-- Plus button: centered, only triggers upload/modal -->
      <div class="plus-btn" @click="onPlusClick">
        <i class="el-icon-plus"></i>
      </div>
      <div class="el-upload-list__item-slot" slot="file" slot-scope="{file}" v-if="file.index === 0">
        <img class="el-upload-list__item-thumbnail" :src="setIcon(file)" alt="" />
        <span class="el-upload-list__item-actions" @click.stop="useModalUpload ? openPreviewSlider() : null">
          <!-- Zoom icon: centered, only this triggers preview -->
          <span class="el-upload-list__item-preview"
            @click.stop="openPreviewSlider();$emit('setGA','Thumbnail Attachments')">
            <i class="el-icon-zoom-in"></i>
          </span>
          <!-- Total count badge -->
          <span class="badge" v-if="attachmentsCountBadge" @click.stop="openPreviewSlider()">
            +{{ attachmentsCountBadge }}
          </span>
          <span class="el-upload-list__item-delete"
            v-else-if="showRemoveDocuments"
            @click="removeAttachment(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </Upload>
    <a class="download-file" />
    <Dialog :visible.sync="dialogVisible" :modal="false">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </Dialog>
  </div>
</template>

<script type="text/javascript">
import AttachmentConstants from "@common/constants/AttachmentConstants";
import UploadMixin from "@common/mixins/UploadMixin";
export default {
  props: {
    attachments: {
      type: Array,
      default: () => [],
    },
    showRemoveDocuments:{
      type: Boolean,
      default: false,
    },
    disableUpload: {
      type: Boolean,
      default: false,
    },
    maxAllowed: {
      type: Number,
      default: 5,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    useModalUpload: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [UploadMixin],
  computed: {
    getAttachments() {
      return this.attachments && this.attachments.map((val,index) => {
        return Object.assign(val, {index});
      });
    },
    attachmentsCountBadge() {
      return this.attachments && this.attachments.length > 1 ? this.attachments.length - 1 : 0;
    },
  },
  methods: {
    onPlusClick() {
      this.$emit('setGA', 'Add Attachment Icon');
      if (this.useModalUpload) {
        this.$emit('addAttachments', null);
      }
    },
    removeAttachment(file) {
      this.$emit('removeAttachments', file);
    },
    openPreviewSlider() {
      this.$emit('openPreviewSlider');
    },
  },
};
</script>
